import { __ } from "./i18n.js";
/**
 * Seller and manufacturer URLs (plus display name) shared by product models,
 * shortcodes and email templates. Each URL passes through `__()` so translators
 * can point at locale-specific landing pages.
 */ function getLegalSellerUrls() {
    return {
        name: "Paddle.com",
        link: __("https://paddle.com"),
        terms: __("https://paddle.com/legal-buyers"),
        privacy: __("https://paddle.com/privacy-buyers")
    };
}
function getLegalManufacturerUrls() {
    return {
        name: "devowl.io GmbH",
        link: __("https://devowl.io/"),
        terms: __("https://devowl.io/terms/"),
        cancellation: __("https://devowl.io/cancellation-policy/"),
        privacy: __("https://devowl.io/privacy-policy/"),
        support: __("https://devowl.io/support/"),
        supportDpa: __("https://devowl.io/dpa-support/")
    };
}
export { getLegalSellerUrls, getLegalManufacturerUrls };
